module.exports = __webpack_public_path__ + "static/media/Empty.fdcfe028.png";